import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { downloadBatchManualClaimActions } from "@/App/actions";

const handleFileDownload = (url: string): void => {
  window.open(url, "_blank");
};

function* downloadBatchManualClaim(payload: string): Generator {
  return yield apiService({
    url: "/transmission/batch_manual/url_for_download",
    method: "POST",
    data: {
      id: payload,
    },
  });
}

export function* downloadBatchManualClaimWorker(action: ReturnType<typeof downloadBatchManualClaimActions.downloadManualClaim>): SagaIterator {
  const { payload } = action;
  const { showPageAlert } = PageAlert;

  try {
    const { url } = yield call(downloadBatchManualClaim, payload);
    yield call(handleFileDownload, url);
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getBatchManualClaimWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.DOWNLOAD_BATCH_TRANSMISSION_MANUAL_CLAIM, downloadBatchManualClaimWorker);
}
